<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <add-new-data-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="addNewDataSidebar = false" />

    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="users" @selected="handleSelected">

	  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

		<div class="flex flex-wrap-reverse items-center">

		  <!-- ACTION - DROPDOWN -->
		  <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">

			<div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
			  <span class="mr-2">Opções</span>
			  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
			</div>

			<vs-dropdown-menu>

			  <vs-dropdown-item>
				<span>Deletar</span>
			  </vs-dropdown-item>
			  <vs-dropdown-item>
				<span>Arquivar</span>
			  </vs-dropdown-item>
			</vs-dropdown-menu>
		  </vs-dropdown>

		  <!-- ADD NEW -->
		  <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewDataSidebar = true">
			  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
			  <span class="ml-2 text-base text-primary">Novo Lançamento</span>
		  </div>
		</div>


		<!-- ITEMS PER PAGE -->
		<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
		  <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
			<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ users.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : users.length }} of {{ users.length }}</span>
			<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
		  </div>
		  <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
		  <vs-dropdown-menu>

			<vs-dropdown-item @click="itemsPerPage=4">
			  <span>4</span>
			</vs-dropdown-item>
			<vs-dropdown-item @click="itemsPerPage=10">
			  <span>10</span>
			</vs-dropdown-item>
			<vs-dropdown-item @click="itemsPerPage=15">
			  <span>15</span>
			</vs-dropdown-item>
			<vs-dropdown-item @click="itemsPerPage=20">
			  <span>20</span>
			</vs-dropdown-item>
		  </vs-dropdown-menu>
		</vs-dropdown>
	  </div>

	  <template slot="thead">
		<vs-th sort-key="name">ID</vs-th>
		<vs-th sort-key="name">TX</vs-th>
    <vs-th sort-key="category">Franquia</vs-th>
		<vs-th sort-key="order_status">Tipo</vs-th>
		<vs-th sort-key="price">Valor</vs-th>
		<vs-th sort-key="price">Data</vs-th>
	  </template>

		<template slot-scope="{data}">
		  <tbody>
			<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

			  <vs-td>
				<p class="product-name font-medium">{{ tr.id }}</p>
			  </vs-td>

			  <vs-td>
				<p class="product-name font-medium">{{ tr.token }}</p>
			  </vs-td>

			  <vs-td>
				<p class="product-category">{{ tr.franquia.nome_franquia }}</p>
			  </vs-td>


			  <vs-td>
				<vs-chip :color="getOrderStatusColor('send')" class="product-order-status">{{ tr.type }}</vs-chip>
			  </vs-td>

			  <vs-td>
				<p class="product-price">R$ {{ tr.valor }} </p>
			  </vs-td>
			  <vs-td>
				<p class="product-price">{{ tr.data }}</p>
			  </vs-td>

			</vs-tr>
		  </tbody>
		</template>
	</vs-table>
  </div>
</template>

<script>
import AddNewDataSidebar from '../CadastroMovimento.vue';

export default {
  components: {
    AddNewDataSidebar
  },
  data() {
    return {
		popupActive: false,
		login_fez: '',
		hash_transacao: '',
		data_transacao: '',
		login_recebeu: '',
		valor_transacao: '',
      selected: [],
      users: [],
      itemsPerPage: 4,
      isMounted: false,
      addNewDataSidebar: false,
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  methods: {
	number_format(number, decimals, decPoint, thousandsSep) {
		number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
		var n = !isFinite(+number) ? 0 : +number
		var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
		var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
		var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
		var s = ''
		var toFixedFix = function (n, prec) {
			var k = Math.pow(10, prec)
			return '' + (Math.round(n * k) / k).toFixed(prec)
		}
		// @todo: for IE parseFloat(0.55).toFixed(0) = 0;
		s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
		if (s[0].length > 3) {
			s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
		}
		if ((s[1] || '').length < prec) {
			s[1] = s[1] || ''
			s[1] += new Array(prec - s[1].length + 1).join('0')
		}
		return s.join(dec)
	},
	handler(login_fez, login_recebeu, hash_transacao, data_transacao, valor_transacao) {
		console.log(hash_transacao);
		this.login_fez = login_fez;
		this.login_recebeu = login_recebeu;

		this.hash_transacao = hash_transacao;
		this.data_transacao = data_transacao;
		this.valor_transacao = valor_transacao;
		this.popupActive = false;
    },
	handleSelected(tr) {

		if(tr.status_order == 'received')
		{
			this.login_fez = tr.login;
			this.login_recebeu = JSON.parse(localStorage.getItem('userInfo')).Login;
		}
		else
		{
			this.login_fez = JSON.parse(localStorage.getItem('userInfo')).Login;
			this.login_recebeu = tr.login;
		}

		this.hash_transacao = tr.hash;
		this.data_transacao = tr.data_gerado;
		this.valor_transacao = tr.valor_total;
		this.popupActive = false;
	},
    getOrderStatusColor(status) {
      if(status == 'received') return "success"
      if(status == 'send') return "danger"
      return "primary"
    },
    getOrderText(status) {
      if(status == 'received') return "Crédito"
      if(status == 'send') return "Débito"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
            obj[key] = fields[key].stringValue || fields[key].integerValue || fields[key].doubleValue;
        }
        return obj
      });
      return formattedData
    }
  },
  created() {
    const thisIns = this;
    fetch(this.$store.state.API_URL + 'Info/Financeiro/Movimentacao', {
		method: 'POST',
		headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
		body: "token="+localStorage.getItem("token")
	})
	.then((response) => response.text())
	.then((responseData) => {

		var dados = JSON.parse(responseData);
		thisIns.users = dados.transacoes;
		thisIns.dadosx = dados.meus_dados;

	});
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.ticket-system {
  max-width: 385px;
}
.ticket-system .top {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.ticket-system .top .title {
  font-weight: normal;
  font-size: 1.6em;
  text-align: left;
  margin-left: 20px;
  margin-bottom: 50px;
  color: #fff;
}
.ticket-system .top .printer {
  width: 90%;
  height: 20px;
  border: 5px solid #fff;
  border-radius: 10px;
  box-shadow: 1px 3px 3px 0px rgba(0, 0, 0, 0.2);
}
.ticket-system .receipts-wrapper {
  overflow: hidden;
  margin-top: -10px;
  padding-bottom: 10px;
}
.ticket-system .receipts {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  transform: translateY(-510px);
  animation-duration: 2.5s;
  animation-delay: 500ms;
  animation-name: print;
  animation-fill-mode: forwards;
}
.ticket-system .receipts .receipt {
  padding: 25px 30px;
  text-align: left;
  min-height: 200px;
  width: 88%;
  background-color: #fff;
  border-radius: 10px 10px 20px 20px;
  box-shadow: 1px 3px 8px 3px rgba(0, 0, 0, 0.2);
}
.ticket-system .receipts .receipt .airliner-logo {
  max-width: 80px;
}
.ticket-system .receipts .receipt .route {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;
}
.ticket-system .receipts .receipt .route .plane-icon {
  width: 30px;
  height: 30px;
  transform: rotate(90deg);
}
.ticket-system .receipts .receipt .route h2 {
  font-weight: 300;
  font-size: 2.2em;
  margin: 0;
}
.ticket-system .receipts .receipt .details {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.ticket-system .receipts .receipt .details .item {
  display: flex;
  flex-direction: column;
  min-width: 70px;
}
.ticket-system .receipts .receipt .details .item span {
  font-size: .8em;
  color: rgba(28, 28, 28, 0.7);
  font-weight: 500;
}
.ticket-system .receipts .receipt .details .item h3 {
  margin-top: 10px;
  margin-bottom: 25px;
}
.ticket-system .receipts .receipt.qr-code {
  height: 110px;
  min-height: unset;
  position: relative;
  border-radius: 20px 20px 10px 10px;
  display: flex;
  align-items: center;
}
.ticket-system .receipts .receipt.qr-code::before {
  content: '';
  background: linear-gradient(to right, #fff 50%, #28C76F 50%);
  background-size: 22px 4px, 100% 4px;
  height: 4px;
  width: 90%;
  display: block;
  left: 0;
  right: 0;
  top: -1px;
  position: absolute;
  margin: auto;
}
.ticket-system .receipts .receipt.qr-code .qr {
  width: 70px;
  height: 70px;
}
.ticket-system .receipts .receipt.qr-code .description {
  margin-left: 20px;
}
.ticket-system .receipts .receipt.qr-code .description h2 {
  margin: 0 0 5px 0;
  font-weight: 500;
}
.ticket-system .receipts .receipt.qr-code .description p {
  margin: 0;
  font-weight: 400;
}

@keyframes print {
  0% {
    transform: translateY(-510px);
  }
  35% {
    transform: translateY(-395px);
  }
  70% {
    transform: translateY(-140px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
<style>
	tspan { white-space:pre }
</style>
